/* eslint-disable */
export default {
  _Bckg: 'Bckg',
  _UIBarTopPhone: 'UIBarTopPhone',
  _UIBarBottomPhone: 'UIBarBottomPhone',
  _UIBarTop: 'UIBarTop',
  _UIBarBottom: 'UIBarBottom',
  _InstructionsPopup: 'InstructionsPopup',
  _PlayBtn: 'PlayBtn',
  _UILevelArea: 'UILevelArea',
  _purpleSheet_purpleSheet2_0: 'purpleSheet/purpleSheet2-0',
  _purpleSheet_purpleSheet2_1: 'purpleSheet/purpleSheet2-1',
  _TitleBlob2: 'TitleBlob2',
  _TitleBlob3: 'TitleBlob3',
  _TitleBlob4: 'TitleBlob4',
  _TitleBlob1: 'TitleBlob1',
  _blob_create_17: 'blob_create/17',
  _blob_create_18: 'blob_create/18',
  _blob_create_20: 'blob_create/20',
  _blob_create_6: 'blob_create/6',
  _blob_create_7: 'blob_create/7',
  _blob_create_22: 'blob_create/22',
  _blob_create_8: 'blob_create/8',
  _blob_create_9: 'blob_create/9',
  _LevelBtn: 'LevelBtn',
  _LevelBtnCleared: 'LevelBtnCleared',
  _LevelBtnLocked: 'LevelBtnLocked',
  _blob_create_10: 'blob_create/10',
  _blob_create_11: 'blob_create/11',
  _blob_create_12: 'blob_create/12',
  _blob_create_13: 'blob_create/13',
  _Block: 'Block',
  _greenSheet_greenSheet_0: 'greenSheet/greenSheet-0',
  _greenSheet_greenSheet_1: 'greenSheet/greenSheet-1',
  _blob_create_14: 'blob_create/14',
  _blob_push_6: 'blob_push/6',
  _blob_create_15: 'blob_create/15',
  _blob_create_16: 'blob_create/16',
  _blob_create_19: 'blob_create/19',
  _blob_create_21: 'blob_create/21',
  _blob_create_4: 'blob_create/4',
  _blob_create_5: 'blob_create/5',
  _blob_create_23: 'blob_create/23',
  _blob_push_7: 'blob_push/7',
  _blob_push_8: 'blob_push/8',
  _blob_rotate_18: 'blob_rotate/18',
  _blob_rotate_0: 'blob_rotate/0',
  _blob_create_2: 'blob_create/2',
  _blob_rotate_19: 'blob_rotate/19',
  _blob_push_5: 'blob_push/5',
  _InstructionsHand: 'InstructionsHand',
  _blob_rotate_16: 'blob_rotate/16',
  _blob_push_9: 'blob_push/9',
  _blob_push_4: 'blob_push/4',
  _blob_push_10: 'blob_push/10',
  _blob_push_11: 'blob_push/11',
  _blob_push_3: 'blob_push/3',
  _blob_create_3: 'blob_create/3',
  _blob_rotate_13: 'blob_rotate/13',
  _blob_rotate_14: 'blob_rotate/14',
  _HelpReticle: 'HelpReticle',
  _blob_rotate_20: 'blob_rotate/20',
  _blob_create_0: 'blob_create/0',
  _blob_create_1: 'blob_create/1',
  _blob_rotate_17: 'blob_rotate/17',
  _blob_create_24: 'blob_create/24',
  _HelpBtn: 'HelpBtn',
  _MenuBtn: 'MenuBtn',
  _MuteBtn: 'MuteBtn',
  _ResetBtn: 'ResetBtn',
  _UnmuteBtn: 'UnmuteBtn',
  _blob_rotate_3: 'blob_rotate/3',
  _blob_rotate_6: 'blob_rotate/6',
  _blob_rotate_10: 'blob_rotate/10',
  _blob_rotate_23: 'blob_rotate/23',
  _blob_rotate_24: 'blob_rotate/24',
  _blob_rotate_25: 'blob_rotate/25',
  _blob_rotate_26: 'blob_rotate/26',
  _blob_rotate_27: 'blob_rotate/27',
  _blob_push_2: 'blob_push/2',
  _blob_rotate_28: 'blob_rotate/28',
  _blob_rotate_22: 'blob_rotate/22',
  _blob_rotate_21: 'blob_rotate/21',
  _blob_rotate_29: 'blob_rotate/29',
  _blob_rotate_30: 'blob_rotate/30',
  _blob_push_1: 'blob_push/1',
  _blob_push_15: 'blob_push/15',
  _BlobFill: 'BlobFill',
  _blob_push_0: 'blob_push/0',
  _blob_push_12: 'blob_push/12',
  _blob_push_16: 'blob_push/16',
  _blob_push_17: 'blob_push/17',
  _blob_push_13: 'blob_push/13',
  _blob_push_14: 'blob_push/14',
  _blob_rotate_2: 'blob_rotate/2',
  _blob_rotate_1: 'blob_rotate/1',
  _blob_rotate_4: 'blob_rotate/4',
  _BlobCreate: 'BlobCreate',
  _blob_rotate_7: 'blob_rotate/7',
  _blob_rotate_5: 'blob_rotate/5',
  _BlobRotate: 'BlobRotate',
  _blob_rotate_15: 'blob_rotate/15',
  _BlobPush: 'BlobPush',
  _blob_rotate_11: 'blob_rotate/11',
  _blob_rotate_12: 'blob_rotate/12',
  _blob_rotate_8: 'blob_rotate/8',
  _blob_rotate_9: 'blob_rotate/9',
  _CloseBtn: 'CloseBtn',
}